import React from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { Button } from 'antd'

import { checkCounterOfferPermissions } from 'app/common/utils/helpers'

// if user can take action on offer, renders Accept and Decline buttons
const OfferActionButtons = ({
  handleOffer,
  offer,
  order,
  request,
}) => {
  const { counterOfferPermission } = useFlags()

  if (offer.status !== 'pending' || order.on_hold || order.lender_canceled || order.appraiser_requested_cancel) {
    // these scenarios prevent taking action on an offer, so we hide the buttons
    return null
  }

  if (counterOfferPermission) {
    const hasPermission = checkCounterOfferPermissions(order, offer)
    if (!hasPermission) {
      // flag is on and user lacks permissions, so we hide the buttons
      return null
    }
  }

  // show Accept + Decline buttons
  return (
    <div>
      <Button
        onClick={() =>
          handleOffer(
            order.id,
            request.id,
            offer.id,
            'accept'
          )
        }
        className='mr-2'
        type='primary'
      >
        Accept Offer
      </Button>
      <Button
        onClick={() =>
          handleOffer(
            order.id,
            request.id,
            offer.id,
            'deny'
          )
        }
        type='danger'
      >
        Decline Offer
      </Button>
    </div>
  )
}

export default OfferActionButtons
